import React from "react";

const STATUS_STYLES = {
  scheduled: "text-[#2563EB] bg-[#2563EB]",
  live: "text-[#0D9947] bg-[#0D9947]",
  settling: "text-[#D97706] bg-[#D97706]",
  ended: "text-[#593A99] bg-[#593A99]",
  cancelled: "text-[#D92D20] bg-[#D92D20]",
};

export function StatusBadge({ status }) {
  return (
    <span
      className={`px-2 py-0.5 text-xs rounded-full font-poppins capitalize bg-opacity-15 ${
        STATUS_STYLES[status] || "text-[#999999] bg-[#999999]"
      }`}
    >
      {status}
    </span>
  );
}

export const formatDuration = (sec) => {
  const s = Number(sec) || 0;
  if (s >= 3600 && s % 3600 === 0) return `${s / 3600} hr`;
  if (s % 60 === 0) return `${s / 60} min`;
  return `${s} sec`;
};

// API times are UTC ISO strings; show them in the admin's local time.
export const formatDateTimeLocal = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleString();
};

export const formatCountdown = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};
